import { render, staticRenderFns } from "./zhuanlan.vue?vue&type=template&id=8903a108"
import script from "./zhuanlan.vue?vue&type=script&lang=js"
export * from "./zhuanlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports